/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Content} from '../common/content';
import {Pie} from '@nivo/pie';
import {PieSvgProps} from '@nivo/pie/dist/types/types';
import {SetRequired} from 'type-fest';
import {Datastores, type ResourceStatus} from '../services/datastores';

export class Home extends React.Component<unknown, {status?: ReadonlyArray<ResourceStatus>}> {
  readonly #symbol = Symbol('Home');

  #responsivePie: SetRequired<
    Partial<PieSvgProps<ResourceStatus['status'][number]>>,
    'margin' | 'borderColor' | 'arcLinkLabel' | 'arcLinkLabelsColor' | 'colors'
  > = {
    margin: {top: 0, right: 120, bottom: 60, left: 120},
    borderColor: {
      from: 'color',
      modifiers: [['darker', 1]],
    },
    colors: (e) => e.data.color,
    arcLinkLabel: (e) => `${e.id} (${e.value})`,
    arcLinkLabelsColor: {from: 'color'},
  };

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.resourceStatus.addObserver(this.#symbol, (status) => {
      this.setState({status});
    });
  }

  override componentWillUnmount() {
    Datastores.resourceStatus.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  override render() {
    return (
      <Content
        section='Home'
        isLoading={this.state === null || this.state.status === undefined}
      >
        <div className='dashboard'>
          {this.state &&
            this.state.status &&
            this.state.status.map((ele) => (
              <div key={ele.display}>
                <h3>{ele.display}</h3>
                {ele.total === 0 ? (
                  <div>No {ele.display.toLocaleLowerCase()} available</div>
                ) : (
                  <Pie
                    width={450}
                    height={400}
                    data={ele.status}
                    margin={this.#responsivePie.margin}
                    activeOuterRadiusOffset={8}
                    colors={this.#responsivePie.colors}
                    borderWidth={1}
                    borderColor={this.#responsivePie.borderColor}
                    arcLinkLabel={this.#responsivePie.arcLinkLabel}
                    arcLinkLabelsColor={this.#responsivePie.arcLinkLabelsColor}
                    arcLinkLabelsSkipAngle={0.1}
                    enableArcLabels={false}
                  />
                )}
              </div>
            ))}
        </div>
      </Content>
    );
  }
}
